// extracted by mini-css-extract-plugin
export default {"app":"App_app__GQ97N","container":"App_container__riHY4"};